module.exports = __webpack_public_path__ + "img/alpha.53db0eb1.png";